
import { Button, Modal } from "react-bootstrap";
import "./create-std-assessment.modal.scss";
import { TextField } from "@mui/material";
import { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClose } from "@fortawesome/free-solid-svg-icons";
import { Question, QuestionLanguage } from "../model/questions-summary.model";
import { v4 as uuidv4 } from 'uuid';
import AI_PURPLE from "../assets/images/ai-icon-purple.png";
interface CreateSTdAssModalProps {
    isOpen: boolean
    onClose(): void
    onSubmitQuestion(any): void

}
const CreateStdAssessmentModal: React.FC<CreateSTdAssModalProps> = ({ isOpen, onClose, onSubmitQuestion }) => {

    const [questionEn, setQuestionEn] = useState<string>("");
    const [questionTh, setQuestionTh] = useState<string>("");



    const handleChange = (field: keyof Question, value, subField?: keyof QuestionLanguage) => {

        if (field == "question" && subField == "en") {
            setQuestionEn(value)
        }
        if (field == "question" && subField == "th") {
            setQuestionTh(value)
        }

    }



    const handleSubmit = () => {
        const body = {
            question: {
                en: questionEn,
                th: questionTh,
            },
            metric: "standard_assessment",
            answer_type: "Free text",
            question_id: uuidv4(),

        }
        onSubmitQuestion(body);

    };
    return (
        <Modal show={isOpen} onHide={onClose} centered backdrop="static" >
            <Modal.Body className="create-std-asm-modal">
                <FontAwesomeIcon icon={faClose} className="create-std-close-icon" onClick={onClose}></FontAwesomeIcon>
                <div className="create-std-asm-topic-control">
                    <img src={AI_PURPLE} className="icon"></img>
                    <span className="create-std-asm-title">สร้างคำถามพิ้นฐานขององค์กรด้วย AI</span>
                </div>
                <span className="create-std-asm-sub-title">กรุณาระบุ URL เว็บไซต์บริษัทของคุณ เพื่อให้ AI ใช้ข้อมูลในการสร้างคำถามพื้นฐานขององค์กร</span>

                <div className="create-std-form-control">
                    <span className="create-std-form-label">คำถาม (ภาษาอังกฤษ)</span>
                    <TextField
                        margin="dense"
                        label=""
                        fullWidth
                        className="create-std-form"
                        placeholder="Question (English)"
                        value={questionEn}
                        onChange={(e) => handleChange("question", e.target.value, "en")}
                    />
                </div>
                <div className="create-std-form-control">
                    <span className="create-std-form-label">คำถาม (ภาษาไทย)</span>
                    <TextField
                        margin="dense"
                        placeholder="Question (Thai)"
                        fullWidth
                        className="create-std-form"
                        value={questionTh}
                        onChange={(e) => handleChange("question", e.target.value, "th")}
                    />
                </div>

               

            </Modal.Body>

        </Modal>
    )


}

export default CreateStdAssessmentModal;